<template>
  <ClientOnly>
    <Teleport to="#modal-portal-target">
      <Modal ref="locationModal" @close="cancelLocation">
        <p>
          <BaseText class="bold">{{
            $t("brochure.location-popup-title")
          }}</BaseText
          ><br />
          <BaseText>{{ $t("brochure.location-popup-text") }}</BaseText>
        </p>
        <LocationAutocompleteInput />
      </Modal>
    </Teleport>
  </ClientOnly>
</template>

<script setup lang="ts">
const location = useLocationState();

// Try to get the location via the browser API
const locationModal = ref<ComponentPublicInstance>();
const { focused } = useFocusWithin(locationModal);

watch(focused, (isFocused) => {
  if (isFocused) setLocation();
});

const setLocation = () => {
  // Try to get the location via the browser geolocation API with vueuse
  const { coords } = useGeolocation();

  // Watch for coordinate updates
  watch(coords, (newCoords) => {
    location.value = { lat: newCoords.latitude, long: newCoords.longitude };
  });
};

// Navigate back when the user dismisses the modal
const cancelLocation = () => {
  window.history.back();
};
</script>

<style lang="scss" scoped></style>
